import { render } from "./ModalConfirmDeactivateMember.vue?vue&type=template&id=6222c730&scoped=true"
import script from "./ModalConfirmDeactivateMember.vue?vue&type=script&lang=js"
export * from "./ModalConfirmDeactivateMember.vue?vue&type=script&lang=js"

import "./ModalConfirmDeactivateMember.vue?vue&type=style&index=0&id=6222c730&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6222c730"]])

export default __exports__